import { faEdit, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { regulationStrategyDelete } from '../../../../../../api/actions/regulation-strategy/regulation-strategy-delete';
import { CommentButton } from '../../../../../../components/comments/comment-button';
import { Button } from '../../../../../../components/shared/button/button';
import { LinkButton } from '../../../../../../components/shared/link-button/link-button';
import { Popup } from '../../../../../../components/shared/popup/popup';
import { compareText } from '../../../../../../helpers/array-helpers';
import { basePerformError } from '../../../../../../helpers/error-helpers';
import { cutStr } from '../../../../../../helpers/string-helpers';
import { EntityTypes } from '../../../../../../models/enums/entity-types';
import { IRegulationStrategy } from '../../../../../../models/regulation-strategy';
import { RegulationStrategyEditor } from './regulation-strategy-editor';

interface IProps extends RouteComponentProps {
    narrativeUid: string,
    participantUid: string,
    title: string,
    regulationStrategies: IRegulationStrategy[],
    reload(): void,
}

function RegulationStrategyManagement(props: IProps) {

    const [editPopupVisible, setEditPopupVisible] = useState(false);
    const [editableEntity, setEditableEntity] = useState<IRegulationStrategy>();
    const [entityForDelete, setEntityForDelete] = useState<IRegulationStrategy>();

    return (<>
        <div className="list-title">
            <div>{props.title}:
                <strong> { props.regulationStrategies.length || 0 }</strong>
            </div>
            <div>
                <Button
                    className="orange"
                    onClick={() => {
                        setEditableEntity(undefined);
                        setEditPopupVisible(true);
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> <span>Add Regulation Strategy</span>
                </Button>
            </div>
        </div>
        { !!props.regulationStrategies.length && (
            <table cellPadding="0" cellSpacing="0" className="list">
                <thead>
                    <tr>
                            <th>Description</th>
                            <th>Intended Outcome</th>
                            <th>Regulation Category</th>
                            <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.regulationStrategies
                        .sort((s1, s2) => compareText(s1, s2, s => s.description) )
                        .map((el: IRegulationStrategy) => (
                            <tr key={el.uid}>
                                <td>
                                    {el.description}
                                </td>
                                <td>
                                    {el.intendedOutcome}
                                </td>
                                <td>
                                    {el.regulationCategory?.name}
                                </td>
                                <td>
                                    <LinkButton
                                        onClick={() => {
                                            setEditableEntity(el);
                                            setEditPopupVisible(true);
                                        } }
                                    >
                                        <FontAwesomeIcon icon={faEdit} /> Edit
                                    </LinkButton><br />
                                    <LinkButton
                                        className="red"
                                        onClick={() => {
                                            setEntityForDelete(el);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} /> Delete
                                    </LinkButton><br />
                                    <CommentButton
                                        isLink={true}
                                        entityType={EntityTypes.regulationStrategy}
                                        entityUid={el.uid}
                                        taskEntityType={EntityTypes.narrative}
                                        taskEntityUid={props.narrativeUid}
                                    />
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        )}

        { editPopupVisible && (
            <Popup
                title={editableEntity ? 'Edit Regulation Strategy' : 'Add Regulation Strategy'}
                modal={true}
            >
                <RegulationStrategyEditor
                    uid={editableEntity?.uid}
                    onClose={() => setEditPopupVisible(false)}
                    participantUid={props.participantUid}
                    reload={props.reload}
                />
            </Popup>
        )}

        { entityForDelete && (
            <Popup
                modal={true}
                className="red"
                title="Delete Regulation Strategy"
                onClose={() => setEntityForDelete(undefined) }
                buttons={[
                    {
                        title: <><FontAwesomeIcon icon={faArrowLeft} /> <span>Cancel</span></>,
                        className: 'gray',
                        onClick: () => setEntityForDelete(undefined),
                    },
                    {
                        title: <><span>Delete</span> <FontAwesomeIcon icon={faTrashAlt} /></>,
                        className: 'red',
                        onClick: async () => {
                            try {
                                const result = await regulationStrategyDelete(entityForDelete.uid);
                                if(result.success) {
                                    props.reload();
                                    toast.success('Item has been successfully delete');
                                    setEntityForDelete(undefined);
                                }
                            }
                            catch(err) {
                                basePerformError(err, props.history);
                            }
                        },
                    },
                ]}
            >
                Are you sure want to delete Regulation Strategy: <strong>{cutStr(entityForDelete.description)}</strong>?
            </Popup>
        )}
    </>);
}

const EmotionManagementWithRouter = withRouter(RegulationStrategyManagement);
export { EmotionManagementWithRouter as RegulationStrategyManagement };
